import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
  Chip,
  Stack,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { AccountCircle, Mail, Phone, Verified, Subscriptions, Edit, Add, FileUpload, LockOpen } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import DiscountIcon from '@mui/icons-material/Discount';
import SchoolCardView from '../view-model/SchoolCardView';
import ModalView from '../model/ModelView';
import SchoolRegister from '../register/SchoolRegister';
import UpdateSchool from '../update-page/EditSchool';
import FileUploadView from '../model/FileUploadView'
import ResetPassword from './ResetPassword';
import SchoolIcon from "@mui/icons-material/School";
// import { Switch, FormControlLabel } from '@mui/material';
import authService from '../Auth/AuthService';
import EmployeeProfile from './EmployeeProfile';
// import '@fortawesome/fontawesome-free/css/all.css';
import ReferralCoupon from '../coupon/ReferralCoupon';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';

const InfoRow = ({ label, value, icon }) => (
  <Grid item xs={12} sm={6}>
    <Box display="flex" alignItems="center" gap={1}>
      {icon}
      <Typography variant="subtitle2" color="text.secondary">
        {label}:
      </Typography>
    </Box>
    <Typography variant="body1" fontWeight="bold">
      {value}
    </Typography>
  </Grid>
);

// const SwitchForm = () => {
//   const [open, setOpen] = useState(true);

//   const employeeProfile = async () => {
//     try {
//       if (!open) {
//         const url = authService.pathUrl("GET", "/teachers/profile");
//         await authService.getAuth(url);
//       }
//     } catch (error) {
//       console.error("Error fetching profile:", error);
//     }
//   }

//   return (
//     <FormControlLabel
//       control={
//         <Switch
//           checked={open}
//           onChange={() => { setOpen(prev => !prev); employeeProfile() }}
//           color="warning"
//         />
//       }
//       label={open ? 'School Details ' : 'My Profile'}
//       sx={{
//         // position: 'fixed',
//         // top: 10,
//         // left: 10,
//         // zIndex: 1400,
//         backgroundColor: '#fff',
//         // px: 1,
//         // borderRadius: 1
//       }}
//     />
//   )
// };

const SubscriptionCard = ({ sub }) => (
  <Paper
    elevation={3}
    sx={{
      p: 3,
      borderLeft: '8px solid #1b1914',
      mb: 3,
      backgroundColor: '#f9f9f9',
      borderRadius: 3,
      // width:'100%'
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
      <Typography variant="subtitle1" fontWeight="bold">
        {sub.subscriptionPlan.name}
      </Typography>
      <Chip
        label={sub.isActive ? 'Active' : 'Inactive'}
        color={sub.isActive ? 'success' : 'default'}
        size="small"
      />
    </Stack>
    <Typography variant="body2">
      <strong>Price:</strong> ₹{sub.subscriptionPlan.price}
    </Typography>
    {sub?.subscriptionPlan?.coupons && (<Box>
      <Typography variant="body2">
        <strong>Coupon :</strong> {sub.subscriptionPlan.coupons.code}
      </Typography>
      <Typography variant="body2">
        <strong>Discount :</strong> ₹{sub.subscriptionPlan.coupons.discountAmount}
      </Typography>
    </Box>
    )}
    <Typography variant="body2">
      <strong>Duration:</strong> {sub.subscriptionPlan.durationInDays} days
    </Typography>
    <Typography variant="body2">
      <strong>Description:</strong> {sub.subscriptionPlan.description}
    </Typography>
    <Typography variant="body2">
      <strong>Start Date:</strong> {sub.startDate}
    </Typography>
    <Typography variant="body2">
      <strong>End Date:</strong> {sub.endDate}
    </Typography>
  </Paper>
);

const ProfileCard = ({ login, school, onSuccess, user }) => {
  const [register, setRegister] = useState(false);
  const [update, setUpdate] = useState(false);
  const [upload, setUpload] = useState(false);
  const [resetPass, setResetPass] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigate = useNavigate();

  const referralCode = login?.masterCode;
  const referralLink = `${window.location.origin}/register?code=${referralCode}`;

  const handleOpen = (e) => {
    if (e === 'update')
      setUpdate(true);
    else if (e === 'upload')
      setUpload(true);
    else if (e === 'reset')
      setResetPass(true);
    else
      setRegister(true);
  }
  const handleClose = () => {
    setRegister(false);
    setUpdate(false);
    setUpload(false);
    setResetPass(false);
  }

  const handleDeleteAccount = async () => {
    try {
      const url = authService.pathUrl("DELETE", "/delete-account");
      await authService.deleteAuth(url);
      authService.logout();
      setDeleteDialogOpen(false);
      navigate("/login");
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  }

  const shareOnWhatsApp = () => {
    const message = `Join our our school management \n${referralLink}`;
    const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const shareByEmail = () => {
    const subject = "Join our our school management";
    const body = `Use my referral code: ${referralCode}\n${referralLink}`;
    const url = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const shareBySMS = () => {
    const message = `Join our our school management\n ${referralLink}`;
    window.location.href = `sms:?body=${encodeURIComponent(message)}`;
  };

  const handleUpdate = async (updatedForm) => {
    console.log('employee update Data:', updatedForm);
    try {
      const url = authService.pathUrl("PUT", "/schools/" + school.id)
      await authService.putAuth(url, updatedForm);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error('Error:', err);
    }
  };


  return (
    <div style={{ padding: 20 }}>
      <Card sx={{ maxWidth: '98%', mx: 'auto', boxShadow: 4 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" >
            <Typography variant="h5" gutterBottom color="#3f2d01" fontWeight={'bold'}>
              <AccountCircle sx={{ mr: 1 }} />
              Login Details
            </Typography>
            <Box>

              <IconButton title='Delete Account' disabled={!user.is_permited?.Delete} onClick={() => setDeleteDialogOpen(true)}>
                <NoAccountsIcon sx={{ color: '#EA4335', fontSize: 30 }} />
              </IconButton>

              <IconButton title='Share On WhatsApp' onClick={shareOnWhatsApp} >
                <WhatsAppIcon sx={{ color: '#25D366', fontSize: 30 }} />
              </IconButton>

              <IconButton title='Share By Email' onClick={shareByEmail} >
                <EmailIcon sx={{ color: '#EA4335', fontSize: 30 }} />
              </IconButton>

              <IconButton title='Share By SMS' onClick={shareBySMS} >
                <SmsIcon sx={{ color: '#34B7F1', fontSize: 30 }} />
              </IconButton>

              <Chip title='Update Subscription'
                component={Link}
                to={'/subscriptionplans'}
                clickable
                label={login?.subscipe?.length > 1 ? 'Active' : 'Subscribe Now'}
                size="medium"
                color={login.id ? 'success' : 'default'}
              />
            </Box>
          </Box>
          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={4}>
            <InfoRow label="Email" value={login.email} icon={<Mail color="action" />} />
            <InfoRow label="Mobile" value={login.mobile} icon={<Phone color="action" />} />
            <InfoRow label="Role Type" value={login.roleType} icon={<Verified color="action" />} />
            <InfoRow label="Login Type" value={login.loginType} icon={<Verified color="action" />} />
            <InfoRow label="Master ID" value={login.masterId} icon={<Verified color="action" />} />
            <InfoRow label="Master Code" value={login.masterCode} icon={<Verified color="action" />} />
            <InfoRow
              label="Mobile Verified"
              value={login.isMobileVerify ? 'Yes' : 'No'}
              icon={<Verified color={login.isMobileVerify ? 'success' : 'disabled'} />}
            />
            <InfoRow
              label="Email Verified"
              value={login.isEmailVerify ? 'Yes' : 'No'}
              icon={<Verified color={login.isEmailVerify ? 'success' : 'disabled'} />}
            />

          </Grid>

          {/* School Detail section */}
          <Box mt={4} >

            <Box display="flex" justifyContent="space-between" >
              <Typography variant="h6" gutterBottom color="#3f2d01" fontWeight={'bold'}>
                <SchoolIcon sx={{ mr: 1 }} />
                Profile Details
              </Typography>
              {login.roleType !== "TEACHER" && (
                <Grid container spacing={2}>
                  <IconButton color="#503901ff" onClick={() => handleOpen('reset')} title='Reset Password'>
                    <LockOpen sx={{ border: '2px solid', fontWeight: 'bold', borderRadius: '10px' }} />
                  </IconButton>
                  {school ? (<>
                    <IconButton color="#503901ff" onClick={() => handleOpen('update')} title='Update Profile'>
                      <Edit sx={{ border: '2px solid', fontWeight: 'bold', borderRadius: '10px' }} />
                    </IconButton>
                    <IconButton color="#503901ff" onClick={() => handleOpen('upload')} title='Upload Logo'>
                      <FileUpload sx={{ border: '2px solid', fontWeight: 'bold', borderRadius: '10px' }} />
                    </IconButton>
                  </>)
                    : (<IconButton color="warning" onClick={() => handleOpen()} title='Add Profile'>
                      <Add sx={{ border: '2px solid', fontWeight: 'bold', borderRadius: '10px' }} />
                    </IconButton>
                    )}
                </Grid>
              )}
            </Box>
            <Divider sx={{ mb: 2 }} />

            {school ? (<>
              <SchoolCardView school={school} />{login.roleType === "TEACHER" && <EmployeeProfile employee={null} />}
            </>) : (
              <Typography variant="body2" color="text.secondary">
                Your profile is incomplete. Please log out and log in again to see the updated data.
              </Typography>
            )}
          </Box>

          {/* Subscription Section */}
          <Box mt={4}>
            <Typography variant="h6" gutterBottom color="#3f2d01" fontWeight={'bold'}>
              <Subscriptions sx={{ mr: 1 }} />
              Subscriptions
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {login.subscipe && login.subscipe.length > 0 ? (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
                  gap: 3,
                }}
              >
                {login.subscipe.map((sub) => (
                  <SubscriptionCard key={sub.id} sub={sub} />
                ))}
              </Box>
            ) : (
              <Typography>No subscriptions found.</Typography>
            )}

          </Box>

          <Box mt={4}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              <DiscountIcon sx={{ mr: 1, verticalAlign: 'middle', color: '#1b1914' }} />
              Rewards
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {login?.userCoupons && login.userCoupons.length > 0 ? (
              <ReferralCoupon data={login?.userCoupons} />
            ) : (
              <Typography>No Rewards found.</Typography>
            )}
          </Box>

        </CardContent>
        <ModalView
          open={register}
          handleClose={handleClose}
          title="Login Profile"
          content={<SchoolRegister />}
        />

        <ModalView
          open={update}
          handleClose={handleClose}
          title="Update Profile"
          content={<UpdateSchool school={school} />}
        />

        <ModalView
          open={upload}
          handleClose={handleClose}
          title="Logo Upload"
          content={<FileUploadView fileType={login.loginType}
            onSuccess={(fileData) => {
              const updatedForm = {
                ...school,
                logoUrl: fileData.path
              };
              setUpload(false);
              handleUpdate(updatedForm);  // 👈 pass fresh data
            }}
          />}
        />

        <ModalView
          open={resetPass}
          handleClose={handleClose}
          title="Reset Password"
          content={<ResetPassword login={login} onSuccess={() => {
            setResetPass(false);
          }}
          />}
        />

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete &quot;{'Your School Acoount'}&quot;?
              This action cannot be recovered.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button
              onClick={handleDeleteAccount}
              color="error"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

      </Card>
    </div>
  );
};

export default ProfileCard;
